export enum PriceOptionEnum {
  NET = 'NET',
  GROSS = 'GROSS',
}
